import React from "react";

const Button = ({
  content = "Sign Up",
  classes = "",
  Icon,
  type = "button",
  onClick = () => {},
  iconClasess = "",
  disabled = false,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`${classes} auth-button`}
      disabled={disabled}
    >
      {Icon && <Icon className={`${iconClasess} w-4 h-4`} />}
      {content}
    </button>
  );
};

export default Button;
